import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import './style.css';
import { flushQueue, refreshQueue } from './lib/queue';
import { initPush } from './lib/push';

createApp(App).use(router).mount('#app');

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => initPush())
      .catch((error) => console.warn('service worker registration failed', error));
  });

  // The service worker asks the page to flush after a Background Sync wake-up.
  navigator.serviceWorker.addEventListener('message', (event) => {
    if ((event.data as { type?: string })?.type === 'flush-queue') void flushQueue();
  });
}

void refreshQueue();

// Background Sync is not available on every browser (notably iOS Safari), so
// the page flushes on its own when connectivity returns.
window.addEventListener('online', () => void flushQueue());
if (navigator.onLine) void flushQueue();
